export default {
    statusTransaksi: [
        {
            id: "fstat-transaksi-1",
            value: "1000",
            title: "Order",
            checked: false,
            titleBold: false,
        },
        {
            id: "fstat-transaksi-5",
            value: "1",
            title: "Belum Selesai",
            checked: false,
            titleBold: false,
        },
        {
            id: "fstat-transaksi-3",
            value: "2",
            title: "Selesai, belum diambil / diantar",
            checked: false,
            titleBold: false,
        },
        {
            id: "fstat-transaksi-4",
            value: "3",
            title: "Selesai, sudah diambil / diantar",
            checked: false,
            titleBold: false,
        },
    ],
    jenisTransaksi: [
        {
            id: "jtrx-1",
            value: "1",
            title: "Reguler",
            checked: false,
            titleBold: false,
        },
        {
            id: "jtrx-2",
            value: "2",
            title: "Deposit",
            checked: false,
            titleBold: false,
        },
        {
            id: "jtrx-3",
            value: "3",
            title: "Dengan Paket Express",
            checked: false,
            titleBold: false,
        },
        {
            id: "jtrx-4",
            value: "4",
            title: "Dengan Akses Mesin",
            checked: false,
            titleBold: false,
        },
    ],
    jenisPembayaran: [
        {
            id: "jenis-pembayaran-1",
            value: "1",
            title: "Tunai",
            checked: false,
            titleBold: false,
        },
        {
            id: "jenis-pembayaran-2",
            value: "3",
            title: "Transfer",
            checked: false,
            titleBold: false,
        },
        // {
        //     id: "jenis-pembayaran-3",
        //     value: "4",
        //     title: "E-payment",
        //     checked: false,
        //     titleBold: false,
        // },
        // {
        //     id: "jenis-pembayaran-4",
        //     value: "10",
        //     title: "QRIS",
        //     checked: false,
        //     titleBold: false,
        // },
        {
            id: "jenis-pembayaran-5",
            value: "11",
            title: "EDC",
            checked: false,
            titleBold: false,
        },
    ],
    statusBayar: [
        {
            id: "skfrm-1",
            value: "0",
            title: "Belum Dibayar",
            checked: false,
            titleBold: false,
        },
        {
            id: "skfrm-2",
            value: "1",
            title: "Terbayar Lunas",
            checked: false,
            titleBold: false,
        },
    ],
    statusBayarAdd: [
        {
            id: "skfrm-1",
            value: "0",
            title: "Belum Dibayar Sama Sekali",
            checked: false,
            titleBold: false,
        },
        {
            id: "skfrm-2",
            value: "3",
            title: "Terbayar Sebagian",
            checked: false,
            titleBold: false,
        },
    ],
    statusInvoice: [
        {
            id: "fstatgaji-1",
            value: "3",
            title: "Lewat jatuh tempo",
            checked: false,
            titleBold: false,
        },
        {
            id: "fstatgaji-2",
            value: "2",
            title: "Dibatalkan",
            checked: false,
            titleBold: false,
        },
        {
            id: "fstatgaji-3",
            value: "1",
            title: "Menunggu konfirmasi",
            checked: false,
            titleBold: false,
        },
    ],
};
